var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPcmPhcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#444F59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.5962V11.7982C15 11.2831 15.4477 10.8655 16 10.8655H28C28.5523 10.8655 29 11.2831 29 11.7982V24.8557C29 25.3708 28.5523 25.7884 28 25.7884H25V28.5865C25 29.1013 24.55 29.5191 23.993 29.5191H12.007C11.7407 29.5206 11.4847 29.423 11.2957 29.248C11.1067 29.073 11.0003 28.8349 11 28.5865L11.003 15.5289C11.003 15.0141 11.453 14.5962 12.01 14.5962H15ZM17 14.5962H25V23.923H27V12.7308H17V14.5962ZM15 19.2596V21.1249H21V19.2596H15ZM15 22.9903V24.8557H21V22.9903H15Z",
    fill: "#444F59",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcmPhcIcon);
export default __webpack_public_path__ + "static/media/PCM-PHC-Icon.1bf8ceb1295468567dc5161254b14b2c.svg";
export { ForwardRef as ReactComponent };